module.exports = __webpack_public_path__ + "img/arrow-right.a0475bf1.svg";